import { API_ORIGIN } from 'constants/api';

import axios from 'axios';

/**
 * API call to fetch the broker's branding info.
 *
 * @method fetchBrandingAPI
 * @param  {number}            partnerId The user to fetch
 * @return {Promise}
 */
export function fetchBrandingAPI(partnerId) {
    return axios({
        baseURL: API_ORIGIN,
        method : 'get',
        url : `/v2/partner-brandings/${partnerId}`
    });
}
